module.exports = __webpack_public_path__ + "img/logo_rsn.a00ff8fb.jpg";